import {
  request
 } from './Base';

/******************************************************************************
 * FETCH FUNCTION                                                             *
 ******************************************************************************/

/**
 * Fetch all transatel rate plans to serve in a dropdown form choice
 */
export function getTransatelRatePlans() {
  return request('/api/transatel/rate_plans');
}

/**
 * Fetch all transatel options to serve in a dropdown form choice
 */
export function getTransatelOptions() {
  return request('/api/transatel/options');
}
